import type { TableColumnDefinition } from "$components/table";
import type { IntlShape } from "react-intl";

export const getViewColumns = (
  formatMessage: IntlShape["formatMessage"],
): TableColumnDefinition[] => [
  {
    field: "date",
    width: 90,
    headerName: formatMessage({
      id: "register.columns.visitDate",
      defaultMessage: "Visit Date",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "name",
    width: 150,
    headerName: formatMessage({
      id: "register.columns.name",
      defaultMessage: "Name",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "phone",
    width: 170,
    headerName: formatMessage({
      id: "register.columns.phone",
      defaultMessage: "Phone",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "sex",
    width: 50,
    headerName: formatMessage({
      id: "register.columns.sex",
      defaultMessage: "Sex",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "age",
    width: 65,
    headerName: formatMessage({
      id: "register.columns.age",
      defaultMessage: "Age",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "address",
    width: 200,
    headerName: formatMessage({
      id: "register.columns.address",
      defaultMessage: "Address",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "diagnoses",
    width: 200,
    headerName: formatMessage({
      id: "register.columns.diagnoses",
      defaultMessage: "Diagnoses",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "prescriptions",
    width: 200,
    headerName: formatMessage({
      id: "register.columns.prescriptions",
      defaultMessage: "Prescriptions",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "investigations",
    width: 200,
    headerName: formatMessage({
      id: "register.columns.investigations",
      defaultMessage: "Investigation titles",
    }),
    verticalAlignContents: "top",
  },
];

export const getDownloadColumns = (
  formatMessage: IntlShape["formatMessage"],
): TableColumnDefinition[] => [
  ...getViewColumns(formatMessage),
  {
    field: "investigationTests",
    width: 150,
    headerName: formatMessage({
      id: "register.columns.investigationTests",
      defaultMessage: "Investigation tests",
    }),
    verticalAlignContents: "top",
  },
  {
    field: "testValues",
    width: 150,
    headerName: formatMessage({
      id: "register.columns.testValues",
      defaultMessage: "Investigation test results",
    }),
  },
];
